import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Tooltip from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { useState } from 'react';
import IconButton from '@mui/material/IconButton';

export default function Helper(props) {

    const [open, setOpen] = useState(false)

    const handleTooltipClose = () => {
        setOpen(false);
    };

    return (
        <>
            <ClickAwayListener onClickAway={handleTooltipClose}>
                <Tooltip
                    PopperProps={{
                        disablePortal: true,
                    }}
                    arrow
                    onClose={handleTooltipClose}
                    open={open}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title={props.text}
                >
                    <IconButton
                        color='primary'
                        onClick={setOpen.bind(this, !open)}
                        style={props.style}
                    >
                        <HelpOutlineIcon
                            fontSize='large'
                        />
                    </IconButton>
                </Tooltip>
            </ClickAwayListener>
        </>
    )
}